import {
    Box,
    Stack,
    SxProps,
    Theme,
    Typography,
    TypographyProps,
} from '@rhg/libs/material';
import { sxAppend } from '@rhg/libs/material/sx';
import React from 'react';

export interface PodSectionProps {
    title: string;
    subtitle?: string;
    icon?: React.JSX.Element;
    titleStyles?: SxProps<Theme>;
    titleComponent?: React.ElementType;
    titleColor?: TypographyProps['color'];
    subtitleColor?: TypographyProps['color'];
    sx?: SxProps<Theme>;
}

const DEFAULT_TITLE_COMPONENT = 'span';

const stylePodSection = {
    p: 6,
    gap: 8,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
};

const stylePodSectionTitle = {
    mb: 2,
};

export function PodSection({
    title,
    subtitle,
    icon,
    titleStyles,
    titleComponent = DEFAULT_TITLE_COMPONENT,
    titleColor = 'text.body',
    subtitleColor = 'text.body',
    sx,
}: PodSectionProps) {
    return (
        <Box sx={sxAppend(stylePodSection, sx)}>
            <Stack>{icon}</Stack>
            <Stack>
                <Typography
                    color={titleColor}
                    textAlign="center"
                    variant="body1Demi"
                    component={titleComponent}
                    sx={titleStyles ?? stylePodSectionTitle}
                >
                    {title}
                </Typography>
                {subtitle && (
                    <Typography
                        color={subtitleColor}
                        component="div"
                        variant="subtitle2"
                        textAlign="center"
                    >
                        {subtitle}
                    </Typography>
                )}
            </Stack>
        </Box>
    );
}
